import { trackEvent } from "@finn-no/pulse-sdk";
import { RefObject, useEffect, useRef } from "react";
import { Recommendation } from "../../types.js";

export const useTrackVisibility = (filteredRecommendations: Recommendation[]) => {
	const trackedIds = useRef<Record<string, boolean | undefined>>({});
	useEffect(() => {
		const shadowRoot = document.querySelector("aurora-mobility-recommendations-podlet-isolated")?.shadowRoot;
		if (!shadowRoot) {
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						trackVisibility(entry, filteredRecommendations, trackedIds);
					}
				});
			},
			{
				root: null,
				threshold: 0.5,
			},
		);

		const elements = shadowRoot.querySelectorAll("[data-item-id]");
		elements.forEach((el) => observer.observe(el));

		return () => {
			elements.forEach((el) => observer.unobserve(el));
		};
	}, [filteredRecommendations]);
};

const trackVisibility = (
	entry: IntersectionObserverEntry,
	filteredRecommendations: Recommendation[],
	trackedIds: RefObject<Record<string, boolean | undefined>>,
) => {
	const target = entry.target as HTMLElement;
	const itemId = target.dataset.itemId;

	const viewEvent = filteredRecommendations
		?.find((item) => item?.itemId === Number(itemId))
		?.tracking?.pulse?.recommendation?.find((event) => event?.type === "View");

	const hasBeenTracked = trackedIds.current[itemId ?? ""];
	if (viewEvent && !hasBeenTracked) {
		trackEvent(viewEvent);
		trackedIds.current[itemId ?? ""] = true;
	}
};
